import React from 'react';
import { validateYouTubeId } from './utils';

interface MlVideoPlayerProps {
  videoId: string;
  title?: string;
  className?: string;
}

export const MlVideoPlayer: React.FC<MlVideoPlayerProps> = ({ videoId, title = 'YouTube video', className = '' }) => {
  const { id, error } = validateYouTubeId(videoId);

  if (error) {
    return (
      <div className={`w-full max-w-full ${className}`}>
        <div className="relative h-0 overflow-hidden bg-gray-100 pt-[56.25%]">
          <div className="absolute left-0 top-0 flex size-full items-center justify-center">
            <p className="px-4 py-2 text-center font-medium text-feedback-error">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  const embedUrl = `https://www.youtube.com/embed/${id}`;

  return (
    <div data-testid="video-container" className={`w-full max-w-full ${className}`}>
      <div className="relative h-0 overflow-hidden pt-[56.25%]">
        <iframe
          className="absolute left-0 top-0 size-full border-0"
          src={embedUrl}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default MlVideoPlayer;
